import { StyleSheet } from "react-native"
import Colors from "../tools/Colors";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
    margin:5
  },
  title: {
    color:"black",
    textAlign: 'center',
    
  },
  categoryStyle:{
    color:"grey",
    textAlign: 'center',
  },
  image: {
    width: 100,
    height: 100,
    marginBottom:3
},
  });
export default styles;  